import React from "react";
import { isMobile } from "react-device-detect";
import { Grid, Link, makeStyles, Typography } from "@material-ui/core";
import logo from "../assets/logo.png";
import logoVisit from "../assets/logo_visit.png";
import { theme } from "../style/theme";
import InfoCard from "../components/InfoCard";
import PromoAppBar from "../components/PromoAppBar";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import FreeBreakfastIcon from "@material-ui/icons/FreeBreakfast";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import VerifiedUserIcon from "@material-ui/icons/VerifiedUser";
import LoyaltyIcon from "@material-ui/icons/Loyalty";
import PT, { AppStoreLink, CompanyEmail, GooglePlayLink } from "../PromoTexts";
import Network from "../network";
import { version } from "../version";

function GetCurrentTranslation(locale: string) {
    if (locale.startsWith("en")) return "en";
    else if (locale.startsWith("ru")) return "ru";
    else if (locale.startsWith("uk")) return "uk";
    else return "en";
}

const useStyles = makeStyles({
    index: {
        backgroundColor: theme.palette.background.default,
        minHeight: window.innerHeight,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    pcBackground: {
        backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='800' height='500' preserveAspectRatio='none' viewBox='0 0 800 500'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1104%26quot%3b)' fill='none'%3e%3crect width='800' height='500' x='0' y='0' fill='rgba(250%2c 245%2c 250%2c 1)'%3e%3c/rect%3e%3cpath d='M758.587%2c407.272C800.994%2c405.841%2c843.269%2c389.47%2c863.918%2c352.402C884.106%2c316.161%2c875.886%2c271.723%2c853.578%2c236.746C833.001%2c204.482%2c796.787%2c189.51%2c758.587%2c187.252C714.939%2c184.672%2c666.648%2c188.171%2c641.923%2c224.233C614.503%2c264.227%2c614.119%2c319.06%2c640.182%2c359.951C664.667%2c398.366%2c713.058%2c408.808%2c758.587%2c407.272' fill='rgba(56%2c 0%2c 96%2c 0.1)' class='triangle-float1'%3e%3c/path%3e%3cpath d='M289.222%2c140.235C323.123%2c140.776%2c355.082%2c126.06%2c374.256%2c98.097C396.569%2c65.555%2c412.494%2c23.392%2c392.771%2c-10.782C373.045%2c-44.962%2c328.686%2c-49.142%2c289.222%2c-49.243C249.513%2c-49.345%2c204.045%2c-46.022%2c184.747%2c-11.317C165.746%2c22.854%2c186.568%2c63.266%2c208.76%2c95.457C227.432%2c122.543%2c256.328%2c139.71%2c289.222%2c140.235' fill='rgba(56%2c 0%2c 96%2c 0.1)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M746.028%2c226.183C787.011%2c227.657%2c832.433%2c217.192%2c851.502%2c180.885C869.79%2c146.065%2c847.622%2c106.677%2c826.074%2c73.775C807.181%2c44.927%2c780.508%2c19.343%2c746.028%2c19.839C712.22%2c20.325%2c687.372%2c47.091%2c669.872%2c76.021C651.532%2c106.338%2c636.9%2c142.141%2c652.927%2c173.742C670.194%2c207.789%2c707.878%2c224.811%2c746.028%2c226.183' fill='rgba(56%2c 0%2c 96%2c 0.1)' class='triangle-float2'%3e%3c/path%3e%3cpath d='M540.091%2c467.083C554.941%2c466.131%2c568.07%2c458.386%2c575.827%2c445.688C583.966%2c432.363%2c587.477%2c415.727%2c579.749%2c402.16C571.957%2c388.482%2c555.825%2c383.455%2c540.091%2c382.954C523.21%2c382.416%2c505.084%2c385.375%2c495.801%2c399.485C485.716%2c414.814%2c485.369%2c435.496%2c495.425%2c450.844C504.73%2c465.046%2c523.147%2c468.17%2c540.091%2c467.083' fill='rgba(56%2c 0%2c 96%2c 0.1)' class='triangle-float3'%3e%3c/path%3e%3cpath d='M142.344%2c220.353C180.11%2c218.239%2c210.909%2c193.543%2c229.906%2c160.834C249.003%2c127.953%2c256.094%2c88.473%2c238.525%2c54.75C219.637%2c18.495%2c183.219%2c-6.613%2c142.344%2c-7.238C100.437%2c-7.879%2c62.346%2c15.701%2c40.929%2c51.728C19.01%2c88.6%2c13.871%2c134.931%2c35.979%2c171.69C57.517%2c207.501%2c100.62%2c222.689%2c142.344%2c220.353' fill='rgba(56%2c 0%2c 96%2c 0.1)' class='triangle-float2'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1104'%3e%3crect width='800' height='500' fill='white'%3e%3c/rect%3e%3c/mask%3e%3cstyle%3e %40keyframes float1 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-10px%2c 0)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float1 %7b animation: float1 5s infinite%3b %7d %40keyframes float2 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(-5px%2c -5px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float2 %7b animation: float2 4s infinite%3b %7d %40keyframes float3 %7b 0%25%7btransform: translate(0%2c 0)%7d 50%25%7btransform: translate(0%2c -10px)%7d 100%25%7btransform: translate(0%2c 0)%7d %7d .triangle-float3 %7b animation: float3 6s infinite%3b %7d %3c/style%3e%3c/defs%3e%3c/svg%3e")`,
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
    },
    img: {
        padding: 20,
        height: isMobile ? "300px" : "350px",
    },
    icon: {
        width: 50,
        height: 50,
    },
    textCaption: {
        fontFamily: theme.typography.fontFamily,
        color: theme.palette.secondary.main,
        textAlign: "center",
        paddingTop: 10,
        paddingBottom: 30,
        fontWeight: "bold",
    },
    contactsPage: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        justifyContent: isMobile ? "flex-start" : "center",
    },
    imgContacts: {
        alignSelf: "center",
        padding: 20,
        height: "300px",
        width: "300px",
    },
    contactsCaption: {
        color: theme.palette.primary.main,
        paddingTop: 10,
        fontWeight: "bold",
        textAlign: "center",
    },
    contactsList: {
        color: theme.palette.text.primary,
    },
    version: {
        marginTop: 50,
        textAlign: "center",
        color: theme.palette.primary.main,
    },
});

export default function PromoScreen(props) {
    const classes = useStyles();

    const [SL, setSelectedLocale] = React.useState(
        GetCurrentTranslation(navigator.language)
    );

    const [selectedPage, setSelectedPage] = React.useState(
        props.selectedPage === undefined ? "mainPage" : props.selectedPage
    );

    const mainPage = () => {
        if (window.location.pathname === "/contacts")
            window.location.href = "/"; // reaload page

        return (
            <>
                <img src={logoVisit} className={classes.img} alt="Visit logo" />
                <Typography
                    variant={isMobile ? "h4" : "h3"}
                    className={classes.textCaption}
                >
                    {PT[SL].promoCaption}
                </Typography>
                <Grid container justifyContent="center">
                    <Grid item>
                        <InfoCard
                            icon={
                                <SupervisorAccountIcon
                                    className={classes.icon}
                                />
                            }
                            SL={SL}
                            cardData={PT[SL].onlineBookingCard}
                        />
                    </Grid>
                    <Grid item>
                        <InfoCard
                            icon={
                                <FreeBreakfastIcon className={classes.icon} />
                            }
                            SL={SL}
                            cardData={PT[SL].bussinessAutomationCard}
                        />
                    </Grid>
                    <Grid item>
                        <InfoCard
                            icon={<LoyaltyIcon className={classes.icon} />}
                            SL={SL}
                            cardData={PT[SL].discountsCard}
                        />
                    </Grid>
                    <Grid item>
                        <InfoCard
                            icon={<AttachMoneyIcon className={classes.icon} />}
                            SL={SL}
                            cardData={PT[SL].statisticsCard}
                        />
                    </Grid>
                    <Grid item>
                        <InfoCard
                            icon={<VerifiedUserIcon className={classes.icon} />}
                            SL={SL}
                            cardData={PT[SL].weWorkForYouCard}
                        />
                    </Grid>
                </Grid>
            </>
        );
    };

    const [serverVersion, setServerVersion] = React.useState("");

    const contactsConstructorHasBeenCalled = React.useRef(false);
    const contactsConstructor = async () => {
        if (contactsConstructorHasBeenCalled.current) return;
        contactsConstructorHasBeenCalled.current = true;
        const resp = await Network.Get("version");
        if (resp.status === 200) {
            setServerVersion(resp.data);
        }
    };

    React.useEffect(() => {
        contactsConstructor();
    });

    React.useEffect(() => {
        // Handle clicking "Back" from contacts pageß
        const handlePopState = () => {
            setSelectedPage("mainPage");
        };

        window.addEventListener("popstate", handlePopState);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, []); // Empty dependency array ensures the effect runs only on mount and unmount

    const contactsPage = () => {
        // Push state to allow user click "Back" in browser
        // to navigate to main page
        window.history.pushState(null, "", window.location.href);

        const mailLink = "mailto:" + CompanyEmail;
        return (
            <div className={classes.contactsPage}>
                <img
                    src={logo}
                    className={classes.imgContacts}
                    alt="Visit logo"
                />
                <Typography variant="h2" className={classes.contactsCaption}>
                    {PT[SL].contacts}
                </Typography>
                <Typography variant={isMobile ? "h5" : "h4"}>
                    <ul className={classes.contactsList}>
                        <li>
                            {PT[SL].mail}
                            <Link href={mailLink} color="secondary">
                                {CompanyEmail}
                            </Link>
                        </li>
                        <li>
                            App Store:{" "}
                            <Link href={AppStoreLink} color="secondary">
                                {PT[SL].navigate}
                            </Link>
                        </li>
                        <li>
                            Google Play:{" "}
                            <Link href={GooglePlayLink} color="secondary">
                                {PT[SL].navigate}
                            </Link>
                        </li>
                    </ul>
                </Typography>
                <Typography
                    className={classes.version}
                    variant="h6"
                >{`cv: ${version}, sv: ${serverVersion}`}</Typography>
            </div>
        );
    };

    const privacyPolicyPage = () => {
        window.location.href = "/privacy";
        return null;
    };

    const termsConditionsPage = () => {
        window.location.href = "/terms";
        return null;
    };

    return (
        <div
            className={
                classes.index + " " + (!isMobile && classes.pcBackground)
            }
        >
            <PromoAppBar
                selectPage={setSelectedPage}
                SL={SL}
                setSelectedLocale={setSelectedLocale}
            />
            {selectedPage === "mainPage" && mainPage()}
            {selectedPage === "contactsPage" && contactsPage()}
            {selectedPage === "privacyPolicyPage" && privacyPolicyPage()}
            {selectedPage === "termsConditionsPage" && termsConditionsPage()}
            {/* Displaying mainPage in the end is needed to avoid blank screen on clicking "Back"
            from privacyPolicyPage or termsConditionsPage */}
            {selectedPage !== "mainPage" &&
                selectedPage !== "contactsPage" &&
                mainPage()}
        </div>
    );
}
